import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { createContext, useContext, useEffect, useState } from 'react'

//#region funciones y variables auxiliares
//#endregion
//#region contexto
const defaultValue = {isDesktop: true, themeX: null};
const DSThemeCtx = createContext(defaultValue);
//#endregion

//#region proveedor
export const DSThemeProvider = ({children}) => {
    const theme = useTheme();
    const [value, setValue] = useState({...defaultValue});
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
        defaultMatches: true
    });
    useEffect(() => {
      setValue(prev => {
        return { ...prev, isDesktop: isDesktop};
      });
    }, [isDesktop]);
    useEffect(() => {
      setValue(prev => {
        return { ...prev, theme: theme};
      });
    }, [theme]);

    return <DSThemeCtx.Provider value={value}>{children}</DSThemeCtx.Provider>;
};
//#endregion
//#region consumidor
export default function useDSThemeCtx() {
  return useContext(DSThemeCtx);
}
//#endregion
